package hk.com.vr360_demo2.webapp.component.marzipano.component

import emotion.react.css
import mui.material.Button
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.AlignItems
import web.cssom.Background
import web.cssom.Border
import web.cssom.Color
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent
import web.cssom.LineStyle
import web.cssom.Padding
import web.cssom.Position
import web.cssom.plus
import web.cssom.px
import kotlin.js.unsafeCast

external interface PendingHotspotDraftPanelProps : Props {
    var anchorX: Double
    var anchorY: Double
    var onCancel: () -> Unit
    var onConfirm: () -> Unit
}

val PendingHotspotDraftPanel = FC<PendingHotspotDraftPanelProps> { props ->
    div {
        css {
            position = Position.absolute
            left = props.anchorX.px
            top = props.anchorY.px + 25.px
            asDynamic().transform = "translateX(-50%)"
            background = "rgba(20,20,20,0.5)".unsafeCast<Background>()
            border = Border(1.px, LineStyle.solid, Color("rgba(255,255,255,0.2)"))
            asDynamic().borderRadius = "8px"
            padding = Padding(10.px, 20.px)
            display = Display.flex
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center
            asDynamic().gap = "8px"
            asDynamic().whiteSpace = "nowrap"
            zIndex = 50.asDynamic()
            asDynamic().pointerEvents = "auto"
            color = Color("#ffffff")
        }
        div {
            css { fontSize = 14.px }
            +"拖動熱點圖標可以調整位置"
        }
        div {
            css {
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
                asDynamic().gap = "30px"
            }
            Button {
                variant = mui.material.ButtonVariant.outlined
                asDynamic().sx = js(
                    """{
                          minHeight: '28px',
                        height: '28px',
                        borderRadius: '4px',
                        color: '#f26522',
                        borderColor: '#f26522',
                        backgroundColor: '#ffffff',
                        minWidth: '56px'
                    }"""
                )
                onClick = { props.onCancel() }
                +"取消"
            }
            Button {
                variant = mui.material.ButtonVariant.contained
                asDynamic().sx = js(
                    """{
                           minHeight: '28px',
                        height: '28px',
                        borderRadius: '4px',
                        backgroundColor: '#f26522',
                        color: '#ffffff',
                        minWidth: '56px'
                    }"""
                )
                onClick = { props.onConfirm() }
                +"確定"
            }
        }
    }
}
